import React from "react"
import { FormattedMessage } from "react-intl"
import { CloudDownload } from "@walmart-web/livingdesign-icons"
import Button from "components/Shared/Button"

type ButtonProps = React.ComponentProps<typeof Button>
type FilterRequestButtonProps = Omit<ButtonProps, "leading" | "children">

const MESSAGE_ID =
	"phronesis.performance.application.filters.requestButton.text"

const FiltersRequestButton = (props: FilterRequestButtonProps) => {
	return (
		<Button {...props} variant="primary" leading={<CloudDownload />}>
			<FormattedMessage id={MESSAGE_ID} />
		</Button>
	)
}

export default FiltersRequestButton
